import { render, staticRenderFns } from "./LoginDirect.vue?vue&type=template&id=32e0be1f&scoped=true"
import script from "./LoginDirect.vue?vue&type=script&lang=js"
export * from "./LoginDirect.vue?vue&type=script&lang=js"
import style0 from "./LoginDirect.vue?vue&type=style&index=0&id=32e0be1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0be1f",
  null
  
)

export default component.exports